import React, { Component } from 'react';

import CommentChat from 'modules/community/commons/CommentChat';
import CommentDetailAnswers from 'modules/community/history/CommentDetailAnswers';
import PropTypes from 'prop-types';

import './CommentTopic.scss';

export default class CommentTopic extends Component {
  static propTypes = {
    item: PropTypes.shape({
      commentClass: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string
      }),
      commentDate: PropTypes.string,
      content: PropTypes.string,
      id: PropTypes.string,
      lastAction: PropTypes.string,
      page: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        module: PropTypes.string
      }),
      status: PropTypes.string,
      type: PropTypes.string,
      user: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        email: PropTypes.string
      })
    }),
    commentStatusUpdate: PropTypes.func,
    commentAnswerReply: PropTypes.func,
    getTopicComments: PropTypes.func
  };

  state = {
    answerBoxOpened: {},
    answerListText: {},
    accordionOpened: {},
    showMoreComments: {}
  };

  constructor(props) {
    super(props);

    this.onAnswerText = this.onAnswerText.bind(this);
    this.toogleAnswer = this.toogleAnswer.bind(this);
    this.onToggleAccordion = this.onToggleAccordion.bind(this);
    this.showMore = this.showMore.bind(this);
  }

  onAnswerText(event, itemId) {
    const { answerListText } = this.state;

    answerListText[itemId] = event.target.value;

    this.setState({ answerListText });
  }

  toogleAnswer(itemId) {
    const { answerBoxOpened } = this.state;

    answerBoxOpened[itemId] = !answerBoxOpened[itemId];

    this.setState({ answerBoxOpened });
  }

  async onToggleAccordion() {
    const { item } = this.props;
    const { accordionOpened } = this.state;
    const itemId = item.id;

    accordionOpened[itemId] = !accordionOpened[itemId];

    this.setState({ accordionOpened, loading: false });
  }

  showMore(itemId) {
    const { showMoreComments } = this.state;

    showMoreComments[itemId] = true;

    this.setState({ showMoreComments });
  }

  render() {
    const { item, commentStatusUpdate, commentAnswerReply } = this.props;
    const {
      answerListText,
      answerBoxOpened,
      showMoreComments,
      accordionOpened
    } = this.state;

    return (
      <div
        className="comment-topic _pt-5 _px-5 _d-flex _flex-column"
        data-test="comment-topic"
      >
        <CommentChat
          item={item}
          commentStatusUpdate={commentStatusUpdate}
          onAnswerText={this.onAnswerText}
          answerListText={answerListText}
          toogleAnswer={this.toogleAnswer}
          commentAnswerReply={commentAnswerReply}
          answerBoxOpened={answerBoxOpened}
          showMoreComments={showMoreComments}
          showMore={this.showMore}
          isTopic
          showStatus
        />

        <CommentDetailAnswers
          item={item}
          accordionOpened={accordionOpened}
          onToggleAccordion={this.onToggleAccordion}
        />
      </div>
    );
  }
}
